export const getDefaultValues = (transctionPackageDetails) => ({
  TransactionPackageLable: transctionPackageDetails?.TransactionPackageLable || '',
  TransactionPackageLogo: transctionPackageDetails?.TransactionPackageLogo || '',
  TransactionPackageAmountOrginal: transctionPackageDetails?.TransactionPackageAmountOrginal || '',
  TransactionPackageDiscountPercent: transctionPackageDetails?.TransactionPackageDiscountPercent || 0,
  TransactionPackageIsActive: transctionPackageDetails?.TransactionPackageIsActive || '',
  TransactionPackageCanUseOnce: transctionPackageDetails?.TransactionPackageCanUseOnce || '',
  TransactionPackageAmountFinal: transctionPackageDetails?.TransactionPackageAmountFinal || '',
  TransactionPackageOrderIndex: transctionPackageDetails?.TransactionPackageOrderIndex || '',
});
